import { z } from "zod";
import { RequestMagicLinkSchema } from "./RequestMagicLink";

export const GetLatestLinkOutputSchema = z.object({
    link: RequestMagicLinkSchema,
    computedExpiryAt: z.string().nullish(), // ISO datetime string
});

export type GetLatestLinkOutput = z.infer<typeof GetLatestLinkOutputSchema>;

